<template>
    <div id="delete-address" class="account-address-delete" uk-modal>
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-default" type="button" uk-close></button>

            <div class="uk-modal-header">
                <h2 class="uk-modal-title">{{ $t('rubinred.ecommerce.core.common.addresses.delete_address_title') }} </h2>
            </div>
            <div class="uk-modal-body">
                <p>{{ $t('rubinred.ecommerce.core.common.addresses.delete_address_text') }}</p>
            </div>
            <div class="uk-modal-footer">
                <div v-cloak>
                    <div class="uk-margin-top uk-flex-right@m uk-grid-small" slot="submit" uk-grid>
                        <div class="uk-width-1-1 uk-width-auto@m">
                            <a v-on:click="removeAddress(addressId)" class="uk-button uk-button-danger uk-width-1-1">{{ $t('frontend-action.delete') }}</a>
                        </div>
                        <div class="uk-flex-first@m uk-width-1-1 uk-width-auto@m">
                            <a class="uk-button uk-button-default uk-width-1-1 uk-modal-close">{{ $t('frontend-action.cancel') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  export default {
      data() {
        return {
          addressId: {
            default: 0,
          }
        }
      },
      methods: {
        removeAddress(id) {
          let self = this;
          let payload = {
            id: self.addressId,
          };
          this.$store.dispatch('addressBook/remove', payload);
          window.App.UIkit.modal(document.querySelector('#delete-address')).hide();

        }
      },
      created() {
        window.App.$on('rubinred.address.remove', addressId => {
          this.addressId = addressId;
          window.App.UIkit.modal(document.querySelector('#delete-address')).show();
        })
      }
    }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/addressing/AddressRemove.vue